import audio from '@/scripts/audio';
import eventHub from '@/scripts/eventHub';
import { random } from 'lodash';
import {
  AnimatedSprite,
  Loader,
  Point,
  Sprite,
} from 'pixi.js';
import state from '../state';
import ticker from '../ticker';
import { hitTest } from '../utils';
import vars from '../vars';
import Actor from './Actor';

class Obstacle extends Actor {
  constructor(parent, player, mode = 'left', width = false) {
    super(parent);
    this.player = player;
    this.mode = mode;
    this.width = width;

    this.sprite = new Sprite();
    const r = random(1, 4, false);
    this.obstacle = new AnimatedSprite(Object.values(Loader.shared.resources[`sprites/OBSTACLE_${r}`].textures));
    this.obstacle.animationSpeed = 0.4;
    this.obstacle.play();
    this.shadow = new Sprite(Loader.shared.resources[`textures/OBSTACLE_${r}_SHADOW`].texture);

    this.frameHandler = () => { this.frame(); };

    this.sprite.addChild(this.shadow);
    this.sprite.addChild(this.obstacle);
    this.resize();
    this.parent.addChild(this.sprite);

    ticker.add(this.frameHandler);
  }

  resize() {
    this.sprite.anchor = this.mode === 'left' ? new Point(0, 0.5) : new Point(1, 0.5);
    this.obstacle.anchor = new Point(0, 0.5);
    this.shadow.anchor = new Point(0, 0.5);
    if (this.mode === 'right') {
      this.sprite.scale.x = -1;
    }
  }

  afterPlace() {
    if (this.mode === 'left') {
      this.sprite.position.x = 0 - (this.width ? vars.layout.GRID_UNIT * (8 - this.width) : random(50, 150, false));
    }
    if (this.mode === 'right') {
      this.sprite.position.x = vars.layout.FRAME_WIDTH - (this.sprite.width - (this.width ? (vars.layout.GRID_UNIT * (8 - this.width)) : random(50, 150, false)));
    }
  }

  frame() {
    const { top } = this.sprite.getBounds();
    this.shadow.position.y = (top - (vars.layout.FRAME_HEIGHT / 2)) * 0.03;
    this.shadow.position.x = (this.player.sprite.position.x - (vars.layout.FRAME_WIDTH / 2)) * 0.05;

    if (
      hitTest(this.sprite, this.player.sprite, 20)
      && !this.player.jumping
      && !this.player.invincible
      && !this.player.isButterfly
    ) {
      // const position = this.mode === 'left' ? vars.layout.FRAME_WIDTH - vars.layout.GRID_UNIT : vars.layout.GRID_UNIT;
      // this.player.setImmediatePosition(position);
      this.player.setTemporaryInvincible(2000, false);
      state.fuel -= 25;
      eventHub.$emit('shake');
      audio.play('obstacle');
    }
  }

  destroy() {
    ticker.remove(this.frameHandler);
  }
}

export default Obstacle;
